import React from 'react';
import { Check } from 'lucide-react';
import './Pricing.css';

const plans = [
    {
        name: "Start",
        price: "5 000",
        yearly: "2 000 kr/år",
        features: ["Hemsida på en sida", "Menyer & prislistor", "Enkel e-postsupport", "Grundläggande SEO", "Mobilanpassad"],
        cta: "Få gratis prototyp",
        featured: false,
        desc: "Perfekt för restauranger, frisörer och mindre företag."
    },
    {
        name: "Standard",
        price: "10 000",
        yearly: "3 500 kr/år",
        features: ["Bokningssystem", "Kontaktformulär", "Flera undersidor", "Prioriterad support", "Avancerad SEO"],
        cta: "Få gratis prototyp",
        featured: true,
        desc: "För företag som behöver ta emot bokningar och förfrågningar."
    },
    {
        name: "Pro",
        price: "30 000",
        originalPrice: "Start från",
        yearly: "från 5 000 kr/år",
        features: ["Inloggning & databas", "E-handel", "Skräddarsydda appar", "Dedikerad support", "Byggd för hög belastning"],
        cta: "Få gratis prototyp",
        featured: false,
        premium: true,
        badge: "För större behov",
        desc: "Komplexa system för större behov och unika funktioner."
    }
];

export default function Pricing({ onSelectPlan }) {
    return (
        <section className="pricing" id="prices">
            <div className="container">
                <div className="section-header">
                    <span className="section-eyebrow">Priser</span>
                    <h2 className="section-title">Tydliga priser, inga överraskningar</h2>
                    <p>En engångskostnad för utveckling, därefter endast en låg årlig avgift för drift och underhåll. Priser kan diskuteras utifrån din budget.</p>
                    <p className="pricing-note">
                        Är du osäker? Vi bygger en <strong>gratis prototyp</strong> först – du betalar ingenting om du inte är nöjd!
                    </p>
                    <a href="/priskalkylator" className="btn-secondary pricing-calc-link">
                        Räkna ut ditt pris med kalkylatorn →
                    </a>
                </div>

                <div className="pricing-grid">
                    {plans.map((plan, index) => (
                        <div className={`pricing-card ${plan.featured ? 'featured' : ''} ${plan.premium ? 'premium' : ''}`} key={index}>
                            {plan.featured && <div className="badge">Mest populär</div>}
                            {plan.premium && plan.badge && <div className="badge">{plan.badge}</div>}
                            <h3 className="plan-name">{plan.name}</h3>
                            {plan.desc && <p className="plan-desc">{plan.desc}</p>}
                            <div className="price">
                                {plan.originalPrice && <span className="price-prefix">{plan.originalPrice}</span>}
                                <span className="currency">kr</span>
                                {plan.price}
                                <span className="price-vat">exkl. moms</span>
                            </div>
                            <span className="price-sub">+ {plan.yearly} drift (startar efter 1 år) exkl. moms</span>

                            <ul className="features-list">
                                {plan.features.map((feature, i) => (
                                    <li key={i}>
                                        <Check size={18} className="check-icon" /> {feature}
                                    </li>
                                ))}
                            </ul>

                            <button
                                className={`btn-plan ${plan.featured ? 'accent' : 'outline'}`}
                                onClick={() => {
                                    onSelectPlan(plan.name);
                                    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                                }}
                            >
                                {plan.cta}
                            </button>
                            <span className="btn-plan-note">Gratis prototyp först – betala när du är nöjd</span>
                        </div>
                    ))}
                </div>

                <p className="pricing-unsure">
                    Osäker på vilket paket som passar? <a href="/priskalkylator">Räkna ut ditt pris på 60 sekunder →</a>
                </p>

                <p className="pricing-disclaimer">
                    *Externa tjänster som Shopify, Supabase Pro, domäner, företagsmail och annonsbudget tillkommer och faktureras separat.
                </p>
            </div>
        </section>
    );
}
